var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179,
    height: 179,
    viewBox: "0 0 179 179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13051",
    "data-name": "Group 13051",
    transform: "translate(344 -7434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5374",
    "data-name": "Path 5374",
    d: "M89.5,0A89.5,89.5,0,1,1,0,89.5,89.5,89.5,0,0,1,89.5,0Z",
    transform: "translate(-344 7434)",
    fill: "#f3f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "image-regular",
    d: "M77.153,40.266a2.764,2.764,0,0,1,2.755,2.755V98.1l-.861-1.119L55.626,66.667a4.143,4.143,0,0,0-6.544,0l-14.294,18.5L29.535,77.81a4.123,4.123,0,0,0-6.716.017L9.041,97.115l-.775,1.068V43.022a2.764,2.764,0,0,1,2.755-2.755ZM11.022,32A11.032,11.032,0,0,0,0,43.022V98.131a11.032,11.032,0,0,0,11.022,11.022H77.153A11.032,11.032,0,0,0,88.175,98.131V43.022A11.032,11.032,0,0,0,77.153,32ZM24.8,65.066A8.266,8.266,0,1,0,16.533,56.8,8.266,8.266,0,0,0,24.8,65.066Z",
    transform: "translate(-298.483 7452.953)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatar);
export default __webpack_public_path__ + "static/media/empty-avatar.d2be84d0ff377d9eb08d1af6c9824f60.svg";
export { ForwardRef as ReactComponent };